export const form = {
	selector: {
		questionnaireSelect: '.js-feedback-settings-questionnaire',
	},
}
